import { render } from "./MbPurchaseStartedatSelect.vue?vue&type=template&id=36cfe306&scoped=true"
import script from "./MbPurchaseStartedatSelect.vue?vue&type=script&lang=js"
export * from "./MbPurchaseStartedatSelect.vue?vue&type=script&lang=js"

import "./MbPurchaseStartedatSelect.vue?vue&type=style&index=0&id=36cfe306&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36cfe306"

export default script